module.exports = __webpack_public_path__ + "static/media/BACKwallBLANK.ac1b7253.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/layers/BACKwallBLANK.png
// module id = 162
// module chunks = 0